import { DashboardLayout } from "@/components";
import { authMiddleware } from "@/middleware";
import { OrderDetails } from "@/pages/orders/details";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_market/orders/$orderId")({
	component: () => {
		const { orderId } = Route.useParams();

		return (
			<DashboardLayout>
				<OrderDetails orderId={orderId} />
			</DashboardLayout>
		);
	},
	loader: authMiddleware,
});
